export const Logo = ({ dark = false, compact = false }) => (
  <span
    aria-label="Exoplus Bio home"
    className={`relative inline-flex items-center ${dark ? "rounded-sm bg-white p-1.5" : ""}`}
  >
    <img src="/logo-cropped.png" alt="Exoplus Bio" className="h-10 w-auto object-contain" />
  </span>
);

export default Logo;
